<template>
  <div
    :key="tag.id"
    class="bg-static-default-low rounded-full caption flex w-fit items-center p-4 pr-8 text-center md:body-2"
  >
    <DynamicIcon class="shrink-0" :icon="tag.icon as IconName" />
    <div class="ml-4 text-left">
      {{ tag.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@backmarket/design-system/icons/icons'
import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'

defineProps<{
  tag: {
    id: string
    text: string
    icon: string
  }
}>()
</script>
